import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { PrintState } from './print-state';

@Injectable()
export class PrintNotifier extends BaseNotifier<PrintState> {
  constructor(ref: Ref) {
    super(ref, { ready: true });
  }
}
